import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiMapErrors extends Layout {
	sourceEdiMapError: DataSource;
	tableError: Table;
}
